import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  headObject: {
    dateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(), 
    dateTo: new Date().toISOString(),
    location: 'ALQ-Hyper',
    status: 'All',
    countStatus: 'All',
    varianceStatus: 'All',
    finalPosting: 'All',
    gridData: [],
  },
  settingSummary : [],
  settingDetail : []
};

const   SliceCyclicPhysicalStockSetting= createSlice({
  name: 'SliceCyclicPhysicalStockSetting',
  initialState,
  reducers: {
    setHeadObject(state, action) {
      state.headObject = { ...state.headObject, ...action.payload };
    },
    addGridRow(state, action) {
      state.headObject.gridData.push(action.payload);
    },
    setSettingSummary(state,action) {
     
      state.settingSummary = action.payload
    },
    setSettingDetail(state,action) {
     
      state.settingDetail = action.payload
    }
  },
});

export const { setHeadObject, addGridRow,setSettingSummary,setSettingDetail } = SliceCyclicPhysicalStockSetting.actions;
export default SliceCyclicPhysicalStockSetting.reducer;
